import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';
import { ChannelImpact } from 'app/model/redshift/impact-report/channel-impact';
import { seamImpactReportService } from 'app/services/seam-request/impact-report.service';
import { ImpactReportGrid } from 'features/qa/impact/impact-report-grid';

export const ChannelReports: React.FunctionComponent = () => {
    const [currentChannels, setCurrentChannels] = useState<ChannelImpact[]>([]);
    const [isProd, setIsProd] = useState(false);

    useEffect(() => {
        const inflightChannelList = seamImpactReportService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_HUGE,
                extraParams: { type: 'channel', prod: isProd },
            })
            .subscribe((data) => setCurrentChannels(data as ChannelImpact[]));

        return () => {
            inflightChannelList.unsubscribe();
        };
    }, [isProd]);

    return (
        <>
            <Typography variant='h5'>Channel Impact Report</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <FormControlLabel
                        control={
                            <Switch checked={isProd} onChange={(evt, checked) => setIsProd(checked)} name='prod' />
                        }
                        label='Prod Data'
                    />
                </Box>
            </Box>
            <ImpactReportGrid type='channel' density='compact' rows={currentChannels} pagination autoPageSize />
        </>
    );
};
